/**
 * @license Siftrock
 * (c) 2014-2019 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

const applicationServerPublicKey = 'BN8mMTBirVyAlkJoSzNiQ4oR4-XipAFR1nzyj8PF5phrN2cSzV3YwPeQtM6ufq_txS7Zfg9EMejoKdGKSyDlVdo';

const urlB64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

@Injectable()
export class ServiceWorkerService {

  constructor(private http: HttpClient) { }

  async install() {
    if (this.isAvailable()) {
      return await this.register();
    }
  }

  async getRegistration() {
    return (await navigator.serviceWorker.getRegistrations())[0];
  }

  async subscribe() {
    const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
    const registration = await this.getRegistration();

    registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey
    })
    .then((subscription) => {
      this.updateSubscriptionOnServer(subscription).subscribe((x) => x);
    })
    .catch((err) => {
      console.warn('Failed to subscribe the user:', err);
    });
  }

  isAvailable(): boolean {
    return 'serviceWorker' in navigator && 'PushManager' in window;
  }

  private async register() {
    const swRegistration = await navigator.serviceWorker.register('assets/js/serviceWorker.js');
    return swRegistration;
  }

  private updateSubscriptionOnServer(subscription): Observable<any> {
    return this.http.post(
      `/api/v1/notifications`,
      subscription
    );
  }

  sendTestNotification(email, message): Observable<any> {
    return this.http.post(`/api/v1/notifications-test/${email}`, message);
  }
}



// WEBPACK FOOTER //
// ./client/app/services/sw.service.ts